import * as angular from "angular";
import * as _ from "lodash";
import {ServiceAreasServiceType} from "../service-areas/angular/types/service-areas-service.type";
import {$agentsFactory} from "../agents/$agents.factory";
import {PricePlanBundleRequestsService} from "../price-plan/services/price-plan-bundle-requests.service";
import {ServiceAnalysisRequestsService} from "../service-analysis/services/service-analysis-requests.service";
import {DateRangeTimeFiltersService} from "../commons/services/date-range-time-filters.service";
import {ViewFilterSettingsService} from "../commons/services/view-filter-settings.service";
import {CommonsService} from "../commons/services/commons-service.service";
import {BranchModel} from "./models/branch.model";
import * as moment from "moment/moment";
import {ScheduleRequestsService} from "../schedule/services/schedule-requests.service";
import {GroupModel} from "../groups/models/group.model";
import {ServiceAreaRequests} from "../service-areas/services/service-area-requests.service";
import {ServiceAreasService} from "../service-areas/services/service-areas-service.service";

angular
  .module('bringoz.admin.branches')
  .config(branchesConfig);

/* @ngInject */
function branchesConfig($stateProvider, moment) {

  $stateProvider

    // Branches
    .state('branches', {
      parent: 'bringoz.site',
      url: '/branches?:currentNavItem&:groupIds&:branchIds&:tags',
      controllerAs: 'vm',
      template: '<branches-groups-view current-nav-item="vm.currentNavItem" group-ids="vm.groupIds" branch-ids="vm.branchIds" tags="vm.tags"></branches-groups-view>',
      controller: function ($scope, triBreadcrumbsService, commonsService, groups, $stateParams, site) {
        this.currentNavItem = $stateParams.currentNavItem;
        this.groupIds = commonsService.parseArrayStateParam($stateParams.groupIds) || [];
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || [];
        this.tags = commonsService.parseArrayStateParam($stateParams.tags) || [];

        if (groups.length) {
          groups.forEach((g: GroupModel) => {
            if (g.branchIds?.length) {
              this.branchIds = _.uniq(this.branchIds.concat(g.branchIds));
            }
          });
        }

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Branches & Groups"});
        triBreadcrumbsService.addCrumb({name: "Operations Management"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        groups: function ($groups, $stateParams, site) {
          return $stateParams.groupIds?.length ? $groups().$asyncValues($stateParams.groupIds) : [];
        }
      }
    })

    // Branch - abstract
    .state('branch', {
      parent: 'bringoz.site',
      url: '/branches/:id',
      template: '<branch-details branch="branch"></branch-details>',
      abstract: true,
      controller: function ($scope, $branches, branch: BranchModel) {
        $scope.branch = branch;
        $branches(branch.id).$bind($scope, 'branch');
      },
      resolve: {
        branch: function ($branches, $stateParams, site) {
          return $branches($stateParams.id).$instantGet();
        }
      }
    })

    // Info
    .state('branch.info', {
      url: '/info',
      pageTrack: '/branch/info',
      template: '<branches-info-view branch="$ctrl.branch" program-types="programTypes"></branches-info-view>',
      controller: function ($scope, triBreadcrumbsService, branch: BranchModel, programTypes) {

        $scope.programTypes = programTypes;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Info"});
        triBreadcrumbsService.addCrumb({name: branch.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Branches & Groups', state: 'branches'});
        triBreadcrumbsService.addCrumb({name: "Operations Management"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        programTypes: function (site, pricePlanBundleRequestsService: PricePlanBundleRequestsService) {
          return pricePlanBundleRequestsService.getSitePrograms();
        }
      }
    })

    // Accounts
    .state('branch.shipper-accounts', {
      url: '/shipper-accounts',
      pageTrack: '/branch/shipper-accounts',
      template: '<branches-shipper-accounts-view branch="$ctrl.branch"></branches-shipper-accounts-view>',
      controller: function ($scope, triBreadcrumbsService, branch: BranchModel) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Shipper Accounts"});
        triBreadcrumbsService.addCrumb({name: branch.name, state: 'branch.shipper-accounts', ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Branches', state: 'branches'});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Depots
    .state('branch.depots', {
      url: '/depots',
      pageTrack: '/branch/depots',
      template: '<branches-depots-view branch="$ctrl.branch"></branches-depots-view>',
      controller: function ($scope, triBreadcrumbsService, branch: BranchModel) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Depots"});
        triBreadcrumbsService.addCrumb({name: branch.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Branches', state: 'branches'});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Agents
    .state('branch.agents', {
      url: '/drivers',
      pageTrack: '/branch/drivers',
      template: '<branches-agents-view branch="$ctrl.branch"></branches-agents-view>',
      controller: function ($scope, triBreadcrumbsService, branch: BranchModel) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Drivers"});
        triBreadcrumbsService.addCrumb({name: branch.name, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Branches', state: 'branches'});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Schedule
    .state('branch.schedule', {
      url: '/schedule',
      pageTrack: '/branch/profile/schedule',
      template: '<branch-schedule-view branch="$ctrl.branch" from="vm.from" to="vm.to" schedule="vm.schedule"></branch-schedule-view>',
      controllerAs: 'vm',
      controller: function () {
        this.from = moment().startOf('week').valueOf();
        this.to = moment().endOf('week').valueOf();
        this.schedule = [];
      },
    })

    // Service Areas
    .state('branch.service-areas', {
      url: '/service-areas',
      pageTrack: '/branch/service-areas',
      template: '<branch-service-areas branch="$ctrl.branch" service-areas="serviceAreas"></branch-service-areas>',
      controller: function ($scope, triBreadcrumbsService, branch: BranchModel, serviceAreas) {

        $scope.serviceAreas = serviceAreas;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Service Areas"});
        triBreadcrumbsService.addCrumb({name: branch.name, state: 'branch.shipper-accounts', ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Branches', state: 'branches'});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        serviceAreas: function (site, branch: BranchModel, serviceAreaRequests: ServiceAreaRequests) {
          return serviceAreaRequests.getAll({branchIds: [branch.id]});
        }
      }
    })

    // Active Services
    .state('branch.active-deliveries', {
      url: '/active-deliveries',
      pageTrack: '/branch/active-deliveries',
      template: '<branch-active-deliveries branch="$ctrl.branch" agents="agents" time-window="timeWindow"></branch-active-deliveries>',
      controller: function ($scope, triBreadcrumbsService, branch: BranchModel, agents) {
        $scope.agents = agents;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Active Services"});
        triBreadcrumbsService.addCrumb({name: branch.name, state: 'branch.shipper-accounts', ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Branches', state: 'branches'});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        agents: function ($agents: $agentsFactory, site, branch: BranchModel) {
          var agentsRef = $agents();
          return agentsRef.$getAll({branchIds: [branch.id], active: true})
            .then((ids: string[]) => {
              return agentsRef.$asyncValues(ids);
            })
        },
        // configuration: function(deliveriesRequestsService, site, branch: BranchModel) {
        //     return deliveriesRequestsService.getAnalysisConfiguration(branch.id);
        // },
      }
    })

    // Services History
    .state('branch.delivery-history', {
      url: '/delivery-history',
      pageTrack: '/branch/delivery-history',
      template: '<branch-delivery-history branch="$ctrl.branch" agents="agents"></branch-delivery-history>',
      controller: function ($scope, triBreadcrumbsService, branch: BranchModel, agents) {

        $scope.agents = agents;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Services History"});
        triBreadcrumbsService.addCrumb({name: branch.name, state: 'branch.shipper-accounts', ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Branches', state: 'branches'});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        agents: function ($agents: $agentsFactory, site, branch: BranchModel) {
          var agentsRef = $agents();
          return agentsRef.$getAll({branchIds: [branch.id], active: true})
            .then((ids: string[]) => {
              return agentsRef.$asyncValues(ids);
            })
        }
      }
    })

    .state('branch.allocations', {
      url: '/allocations?:from&:to&:serviceAreaIds&:agentType&:isActive&:agentSkills&:branchIds&:depotIds&:customerIds&:accountIds&:queryString',
      controllerAs: 'vm',
      template: '<resources-allocations-view from="vm.from" to="vm.to" '
        + 'view-type="vm.viewType" '
        + 'branch-ids="vm.branchIds" '
        + 'service-area-ids="vm.serviceAreaIds" service-areas="vm.serviceAreas" agent-type="vm.agentType" query-string="vm.queryString" agent-skills="vm.agentSkills"' +
        ' is-active="vm.isActive" account-ids="vm.accountIds" depot-ids="vm.depotIds" customer-ids="vm.customerIds" branch-ids="vm.branchIds"></resources-allocations-view>',
      controller: function (branch: BranchModel, serviceAreas, viewFilterSettingsService: ViewFilterSettingsService, $state, dateRangeTimeFiltersService: DateRangeTimeFiltersService,
                            $stateParams, commonsService: CommonsService, triBreadcrumbsService) {

        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);
        this.from = moment().startOf('week').valueOf();
        this.to = moment().endOf('week').valueOf();

        this.viewType = 'week';
        this.selectedQuickFilterId = quickActiveFilter?.id;

        this.serviceAreaIds = commonsService.parseArrayStateParam($stateParams.serviceAreaIds) || quickActiveFilter?.settings.serviceAreaIds || [];
        this.serviceAreas = serviceAreas || [];
        this.agentType = $stateParams.agentType || quickActiveFilter?.settings.agentType;
        this.isActive = !_.isUndefined($stateParams.isActive) ? JSON.parse($stateParams.isActive) : (!_.isUndefined(quickActiveFilter?.settings?.isActive) ? quickActiveFilter?.settings.isActive : true);
        this.agentSkills = commonsService.parseArrayStateParam($stateParams.agentSkills) || quickActiveFilter?.settings.agentSkills;
        this.queryString = $stateParams.queryString;
        this.depotIds = commonsService.parseArrayStateParam($stateParams.depotIds) || quickActiveFilter?.settings.depotIds;
        this.accountIds = commonsService.parseArrayStateParam($stateParams.accountIds) || quickActiveFilter?.settings.accountIds;
        this.customerIds = commonsService.parseArrayStateParam($stateParams.customerIds) || quickActiveFilter?.settings.customerIds;
        this.branchIds = [branch.id];

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Allocations"});
        triBreadcrumbsService.addCrumb({name: branch.name, state: 'branch.shipper-accounts', ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Branches', state: 'branches'});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        serviceAreas: function ($serviceArea, serviceAreasService: ServiceAreasService, branch: BranchModel) {
          // var serviceAreasRef = $serviceArea();
          var payload = {
            serviceTypes: ServiceAreasServiceType.Planning,
            branchIds: [branch.id]
          };
          return serviceAreasService.getAll(payload);
        }
      }
    })

    // Planning - Abstract
    .state('branch.planning', {
      url: '/planning',
      abstract: true,
      template: '<ui-view>'
    })

    // Planning - Plan
    .state('branch.planning.plan', {
      url: '/plan?:from&:to&:areaIds&:considerArea&:considerTimeWindows&:maxDeliveries&:onlyUnRouted&:onlyInStore&:branchId',
      pageTrack: '/branch/planning/plan',
      template: '<lean-planning-view segments="segments" from="from" to="to" consider-area="considerArea" open-process-ids="openProcessIds"' +
        'consider-time-windows="considerTimeWindows" service-area-ids="serviceAreaIds" only-in-store="onlyInStore"' +
        'only-un-routed="onlyUnRouted" max-deliveries="maxDeliveries" branch-id="branchId" disable-branch="true"></lean-planning-view>',
      controller: function ($scope, triBreadcrumbsService, $stateParams, branch: BranchModel, analysis, generatingRoutes, configuration, serviceAreas) {

        $scope.segments = analysis;

        $scope.from = $stateParams.from ? parseInt($stateParams.from) : moment().startOf('day').valueOf();
        $scope.to = $stateParams.to ? parseInt($stateParams.to) : moment().endOf('day').valueOf();
        $scope.serviceAreaIds = $stateParams.areaIds || _.map(serviceAreas, function (area) {
          return area.areaId;
        });
        $scope.considerArea = $stateParams.considerArea ? _.isEqual($stateParams.considerArea, 'true') : configuration.considerServiceArea;
        $scope.considerTimeWindows = $stateParams.considerTimeWindows ? _.isEqual($stateParams.considerTimeWindows, 'true') : configuration.considerTimeWindows;
        $scope.maxDeliveries = $stateParams.maxDeliveries ? parseInt($stateParams.maxDeliveries) : configuration.numberOfServicePerRoute;
        $scope.onlyUnRouted = $stateParams.onlyUnRouted ? _.isEqual($stateParams.onlyUnRouted, 'true') : configuration.onlyUnRouted;
        $scope.onlyInStore = $stateParams.onlyInStore ? _.isEqual($stateParams.onlyInStore, 'true') : configuration.onlyInStore;
        $scope.branchId = branch.id;

        $scope.openProcessIds = _.map(generatingRoutes, function (generatingRoute) {
          return generatingRoute.id;
        });

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Lean Planning"});
        triBreadcrumbsService.addCrumb({name: "Planning"});
        triBreadcrumbsService.addCrumb({name: branch.name, state: 'branch.shipper-accounts', ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Branches', state: 'branches'});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        analysis: function (deliveriesRequestsService, $stateParams, site, configuration, branch: BranchModel) {
          return deliveriesRequestsService.getAnalysis(
            moment().startOf('day').valueOf(),
            moment().endOf('day').valueOf(),
            $stateParams.areaIds || [],
            configuration.considerServiceArea,
            configuration.considerTimeWindows,
            configuration.onlyInStore,
            configuration.numberOfServicePerRoute,
            configuration.onlyUnRouted || false,
            [branch.id]
          )
        },
        generatingRoutes: function (serviceAnalysisRequestsService: ServiceAnalysisRequestsService, site, branch: BranchModel) {
          return serviceAnalysisRequestsService.getGeneratingRoutes(branch.id);
        },
        configuration: function (deliveriesRequestsService, site, branch: BranchModel) {
          return deliveriesRequestsService.getAnalysisConfiguration(branch.id);
        },
        serviceAreas: function (serviceAreaRequests, branch: BranchModel) {
          return serviceAreaRequests.getAll({branchIds: [branch.id]})
        }
      }
    })

    // Planning - Routes
    .state('branch.planning.routes', {
      url: '/routes?:from&:to&:areaIds&:status&:agentIds&:routeIds&:resourceIds',
      pageTrack: '/branch/planning/routes',
      controllerAs: 'vm',
      template: '<planning-routes from="vm.from" to="vm.to" area-ids="vm.areaIds" ids="vm.routeIds" ' +
        'branch-ids="vm.branchIds" agent-ids="vm.agentIds" resource-ids="vm.resourceIds" branch-mode="true"></planning-routes>',
      controller: function (triBreadcrumbsService, commonsService: CommonsService, $stateParams, branch: BranchModel) {

        this.routeIds = $stateParams.routeIds ? commonsService.parseArrayStateParam($stateParams.routeIds) : undefined;
        this.areaIds = $stateParams.areaIds ? commonsService.parseArrayStateParam($stateParams.areaIds) : undefined;
        this.branchIds = [branch.id];
        this.agentIds = $stateParams.agentIds ? commonsService.parseArrayStateParam($stateParams.agentIds) : undefined;
        this.resourceIds = $stateParams.resourceIds ? commonsService.parseArrayStateParam($stateParams.resourceIds) : undefined;

        if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from);
          this.to = parseInt($stateParams.to);
        } else {
          this.from = moment().startOf('day').valueOf();
          this.to = moment().endOf('day').valueOf();
        }

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Routes"});
        triBreadcrumbsService.addCrumb({name: "Planning"});
        triBreadcrumbsService.addCrumb({name: branch.name, state: 'branch.shipper-accounts', ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Branches', state: 'branches'});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

    // Planning - Settings
    .state('branch.planning.settings', {
      url: '/settings',
      pageTrack: '/branch/planning/settings',
      template: '<planning-configuration configuration="configuration" branch-id="branchId"></planning-configuration>',
      controller: function ($scope, triBreadcrumbsService, branch: BranchModel, configuration) {

        $scope.branchId = branch.id;
        $scope.configuration = configuration;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Routing Settings"});
        triBreadcrumbsService.addCrumb({name: "Planning"});
        triBreadcrumbsService.addCrumb({name: branch.name, state: 'branch.shipper-accounts', ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Branches', state: 'branches'});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        configuration: function (deliveriesRequestsService, site, branch: BranchModel) {
          return deliveriesRequestsService.getAnalysisConfiguration(branch.id);
        },
      }
    })

}
